/* ChartCard auto-generated by npm run generator */
import { makeStyles, Theme, Typography } from "@material-ui/core"
import { observer } from "mobx-react"
import React from "react"

interface ChartCardProps {
    children?: React.ReactNode
    title: string
    subtitle: string
}

const useStyles = makeStyles((theme: Theme) => ({
    chartCardAtom: {
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 0px 2px rgba(0, 0, 0, 0.14)",
        borderRadius: 4,
        padding: theme.spacing(2),
        width: "fit-content",
        display: "grid",
    },
}))

const ChartCard: React.FC<ChartCardProps> = (props) => {
    const classes = useStyles()

    return (
        <div className={classes.chartCardAtom}>
            <Typography variant="h6">{props.title}</Typography>
            {props.children}
            <Typography variant="subtitle1" color="textSecondary">
                {props.subtitle}
            </Typography>
        </div>
    )
}
export default observer(ChartCard)
